
/**
 * 미디어 유형
 */
export type MediaFileResponseType = typeof MediaFileResponseType[keyof typeof MediaFileResponseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaFileResponseType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
